import dayjs from 'dayjs';

export const calculateTimeLeft = (raceStartTime: bigint) => {
  const now = dayjs().unix(); // Current time in seconds
  const timeLeftSeconds = Math.max(0, Number(raceStartTime) - now);

  return {
    hours: Math.floor(timeLeftSeconds / 3600),
    minutes: Math.floor((timeLeftSeconds % 3600) / 60),
    seconds: timeLeftSeconds % 60,
  };
};
